module.exports = __webpack_public_path__ + "img/31.125c5b84.svg";